import KpiHome from '../../components/kpi/KpiHome';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';

import { fetchUsersInteraction } from '../../modules';
import API from '../../../../../utils/api';

let pollingRealtime;

const mapDispatchToProps = dispatch => ({
  fetchUsersInteraction(listUsersWithData, from, to, userAnonymous) {
    dispatch(fetchUsersInteraction(listUsersWithData, from, to, userAnonymous));
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
    listInteractions: _.get(state, 'analytics.listInteractions', []),
    listUsersInteraction: _.get(state, 'analytics.listUsersInteraction', []),
    showAnonymousUsers: _.get(state, 'analytics.showAnonymousUsers', true),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('selectedTab', 'updateSelectedTab', 1),
  withState('loadingCohort', 'setLoadingCohort', true),
  withState('loadingGraphs', 'setLoadingGraphs', true),
  withState('loadingEventClicks', 'setLoadingEventClicks', true),
  withState('loadingPageViews', 'setLoadingPageViews', true),
  withState('totalActiveUsers', 'setTotalActiveUsers', 0),
  withState('totalNewUsers', 'setTotalNewUsers', 0),
  withState('totalEngagementAverage', 'setTotalEngagementAverage', 0),
  withState('totalSessionAverage', 'setTotalSessionAverage', 0),
  withState('activeUserRealtime', 'setActiveUserRealtime', 0),
  withState('activeUsers', 'setActiveUsers', []),
  withState('newUsers', 'setNewUsers', []),
  withState('userEngagement', 'setUserEngagement', []),
  withState('cohortData', 'setCohortData', []),
  withState('userSession', 'setUserSession', []),
  withState('listProjects', 'setListProjects', [
    'APP',
    'SKYDOMESPORTS',
    'BCLC',
    'PLAY',
  ]),
  withState('projectSelected', 'setProjectSelected', 'APP'),
  withState('pageViewCards', 'setPageViewCards', []),
  withState('eventCards', 'setEventCards', []),
  withState(
    'dateFrom',
    'setDateFrom',
    moment()
      .subtract(7, 'd')
      .toDate()
  ),
  withState('dateTo', 'setDateTo', moment().toDate()),
  withState('locationSelected', 'setLocationSelected', 'country'),
  withState('locationData', 'setLocationData', []),
  withHandlers({
    parseRealtimeReportData: props => data => {
      const activeUserRealtime = _.get(
        data,
        'totals.0.metricValues.0.value',
        0
      );
      if (pollingRealtime) {
        props.setActiveUserRealtime(activeUserRealtime);
      }
    },
    parseReportData: props => data => {
      const report = _.get(data, 'reports.0', null);
      const dateInterval = moment(props.dateTo).diff(
        moment(props.dateFrom),
        'days'
      );
      let activeUsers = [];
      let newUsers = [];
      let userEngagement = [];
      let userSession = [];
      for (let i = 0; i <= dateInterval; i++) {
        const currentDate = moment(props.dateFrom)
          .add(i, 'd')
          .format('YYYY-MM-DD');
        activeUsers[i] = { date: currentDate, value: 0 };
        newUsers[i] = { date: currentDate, value: 0 };
        userEngagement[i] = { date: currentDate, value: 0 };
        userSession[i] = { date: currentDate, value: 0 };
      }

      if (report) {
        const totalActiveUsers = _.get(
          report,
          'totals.0.metricValues.0.value',
          0
        );
        const totalNewUsers = _.get(report, 'totals.0.metricValues.1.value', 0);
        const engagementTotalUser = _.get(
          report,
          'totals.0.metricValues.2.value',
          0
        );

        const sessionTotalUser = _.get(
          report,
          'totals.0.metricValues.3.value',
          0
        );

        const totalActiveUsersFloat = parseFloat(totalActiveUsers);
        if (totalActiveUsersFloat > 0) {
          const totalEngagementAverage =
            parseFloat(engagementTotalUser) / totalActiveUsersFloat;
          props.setTotalEngagementAverage(totalEngagementAverage);

          const totalSessionAverage =
            parseFloat(sessionTotalUser) / totalActiveUsersFloat;
          props.setTotalSessionAverage(totalSessionAverage.toFixed(2));
        } else {
          props.setTotalEngagementAverage(0);
          props.setTotalSessionAverage(0);
        }

        props.setTotalActiveUsers(totalActiveUsers);
        props.setTotalNewUsers(totalNewUsers);
        const rows = _.get(report, 'rows', []);
        rows.forEach(row => {
          let dimensionData = _.get(row, 'dimensionValues.0.value', '0');
          dimensionData = parseInt(dimensionData);
          const activeUserData = _.get(row, 'metricValues.0.value', 0);
          const newUserData = _.get(row, 'metricValues.1.value', 0);
          const userEngagementData = _.get(row, 'metricValues.2.value', '0');
          const userSessionData = _.get(row, 'metricValues.3.value', '0');

          const dateValue = moment(props.dateFrom)
            .add(dimensionData, 'days')
            .format('YYYY-MM-DD');
          activeUsers[dimensionData] = {
            date: dateValue,
            value: activeUserData,
          };
          newUsers[dimensionData] = {
            date: dateValue,
            value: newUserData,
          };

          const activeUserDataInt = parseInt(activeUserData);
          if (activeUserDataInt > 0) {
            const engagementAverage =
              parseFloat(userEngagementData) / parseInt(activeUserData);
            userEngagement[dimensionData] = {
              date: dateValue,
              value: engagementAverage.toFixed(),
            };

            const sessionAverage =
              parseFloat(userSessionData) / parseInt(activeUserData);
            userSession[dimensionData] = {
              date: dateValue,
              value: sessionAverage.toFixed(2),
            };
          }
        });
        props.setActiveUsers(activeUsers);
        props.setNewUsers(newUsers);
        props.setUserEngagement(userEngagement);
        props.setUserSession(userSession);
      }
    },
    parseCohortReportData: props => (data, limitWeeks) => {
      const rows = _.get(data, 'reports.0.rows', []);
      let cohortData = [];
      for (let i = 0; i < limitWeeks; i++) {
        cohortData[i] = {
          week: 'week ' + i,
        };
      }
      rows.forEach(row => {
        let dimensionData = _.get(row, 'dimensionValues.1.value', '-1');
        dimensionData = parseInt(dimensionData);
        const activeUserData = _.get(row, 'metricValues.0.value', '0');
        if (dimensionData >= 0) {
          cohortData[dimensionData] = {
            week: 'week ' + dimensionData,
            value: (parseFloat(activeUserData) * 100).toFixed(2),
          };
        }
      });
      props.setCohortData(cohortData);
    },
    parseLocationData: props => data => {
      let locationData = [];

      const rows = _.get(data, 'reports.0.rows', []);
      rows.forEach(row => {
        let dimensionData = _.get(row, 'dimensionValues.0.value', null);
        const activeUserData = _.get(row, 'metricValues.0.value', '0');

        if (dimensionData) {
          locationData.push({ location: dimensionData, users: activeUserData });
        }
      });
      props.setLocationData(locationData);
    },
  }),
  withHandlers({
    getKpiRealtime: props => () => {
      const dimensions = [];
      const metrics = [{ name: 'activeUsers' }];
      const metricAggregations = ['TOTAL'];
      const filter = { dimensions, metrics, metricAggregations };

      return API.getKpiRealtime({
        project: props.projectSelected,
        filter,
      }).then(data => {
        props.parseRealtimeReportData(data);
      });
    },
  }),
  withHandlers({
    getKpiUserRetention: props => () => {
      props.setLoadingCohort(true);
      const dateTo = moment(props.dateTo).format('YYYY-MM-DD');
      const dateFrom = moment(props.dateFrom).format('YYYY-MM-DD');
      const weekEndOffset = 6;
      const dimensions = [{ name: 'cohort' }, { name: 'cohortNthWeek' }];
      const metrics = [
        {
          name: 'cohortRetentionFraction',
          expression: 'cohortActiveUsers/cohortTotalUsers',
        },
      ];
      const cohortSpec = {
        cohorts: [
          {
            dimension: 'firstSessionDate',
            dateRange: {
              startDate: dateFrom,
              endDate: dateTo,
            },
          },
        ],
        cohortsRange: {
          endOffset: weekEndOffset,
          granularity: 'WEEKLY',
        },
      };
      const keepEmptyRows = true;
      const filter = { dimensions, metrics, cohortSpec, keepEmptyRows };

      return API.getGoogleReport({
        project: props.projectSelected,
        filter,
      }).then(data => {
        props.parseCohortReportData(data, weekEndOffset);
        props.setLoadingCohort(false);
      });
    },
  }),
  withHandlers({
    getKpiAnalytics: props => () => {
      props.setLoadingGraphs(true);
      const dateTo = moment(props.dateTo).format('YYYY-MM-DD');
      const dateFrom = moment(props.dateFrom).format('YYYY-MM-DD');

      const dateRanges = [
        {
          startDate: dateFrom,
          endDate: dateTo,
        },
      ];

      const dimensions = [
        {
          name: 'nthDay',
        },
      ];

      const metrics = [
        {
          name: 'activeUsers',
        },
        {
          name: 'newUsers',
        },
        {
          name: 'userEngagementDuration',
        },
        {
          name: 'engagedSessions',
        },
      ];

      const orderBys = [
        {
          dimension: { dimensionName: 'nthDay', orderType: 'ALPHANUMERIC' },
        },
      ];

      const metricAggregations = ['TOTAL'];

      return API.getGoogleReport({
        project: props.projectSelected,
        filter: {
          dateRanges,
          dimensions,
          metrics,
          orderBys,
          metricAggregations,
        },
      }).then(data => {
        props.parseReportData(data);
        props.setLoadingGraphs(false);
      });
    },
  }),
  withHandlers({
    getPageViews: props => () => {
      props.setLoadingPageViews(true);
      const dateTo = moment(props.dateTo).format('YYYY-MM-DD');
      const dateFrom = moment(props.dateFrom).format('YYYY-MM-DD');

      const dateRanges = [
        {
          startDate: dateFrom,
          endDate: dateTo,
        },
      ];

      const dimensions = [
        {
          name: 'pagePath',
        },
      ];

      const metrics = [
        {
          name: 'screenPageViews',
        },
      ];

      const orderBys = [
        {
          metric: { metricName: 'screenPageViews', orderType: 'NUMBER' },
          desc: true,
        },
      ];

      API.getGoogleReport({
        project: props.projectSelected,
        filter: {
          dateRanges,
          dimensions,
          metrics,
          orderBys,
        },
      }).then(data => {
        let rows = _.get(data, 'reports.0.rows', []);

        rows = rows.map(row => {
          const data = _.get(row, 'metricValues.0.value', null);
          const title = _.get(row, 'dimensionValues.0.value', null);

          return { data, title };
        });

        props.setPageViewCards(rows);
        props.setLoadingPageViews(false);
      });
    },
    getEventClick: props => () => {
      props.setLoadingEventClicks(true);
      const dateTo = moment(props.dateTo).format('YYYY-MM-DD');
      const dateFrom = moment(props.dateFrom).format('YYYY-MM-DD');

      const dateRanges = [
        {
          startDate: dateFrom,
          endDate: dateTo,
        },
      ];

      const dimensions = [
        {
          name: 'eventName',
        },
      ];

      const metrics = [{ name: 'eventCount' }];

      const orderBys = [
        {
          metric: { metricName: 'eventCount', orderType: 'NUMBER' },
          desc: true,
        },
      ];

      API.getGoogleReport({
        project: props.projectSelected,
        filter: {
          dateRanges,
          dimensions,
          metrics,
          orderBys,
        },
      }).then(data => {
        let rows = _.get(data, 'reports.0.rows', []);
        let events = [];
        for (const row of rows) {
          const data = _.get(row, 'metricValues.0.value', null);
          const title = _.get(row, 'dimensionValues.0.value', null);
          if (
            ![
              'scroll',
              'page_view',
              'user_engagement',
              'session_start',
              'first_visit',
            ].includes(title)
          ) {
            events.push({ data, title });
          }
        }

        props.setEventCards(events);
        props.setLoadingEventClicks(false);
      });
    },
    getLocation: props => () => {
      const dateTo = moment(props.dateTo).format('YYYY-MM-DD');
      const dateFrom = moment(props.dateFrom).format('YYYY-MM-DD');

      const dateRanges = [{ startDate: dateFrom, endDate: dateTo }];

      const dimensions = [{ name: props.locationSelected }];

      const metrics = [{ name: 'activeUsers' }];

      const orderBys = [];

      API.getGoogleReport({
        project: props.projectSelected,
        filter: { dateRanges, dimensions, metrics, orderBys },
      }).then(data => {
        props.parseLocationData(data);
      });
    },
  }),
  withHandlers({
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
    refreshData: props => () => {
      props.getKpiUserRetention();
      props.getKpiAnalytics();
      props.getPageViews();
      props.getEventClick();
      props.getLocation();
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {
      this.props.refreshData();
      this.props.getKpiRealtime();
      pollingRealtime = setInterval(() => this.props.getKpiRealtime(), 10000);
    },
    componentWillUnmount() {
      clearInterval(pollingRealtime);
      pollingRealtime = null;
    },
  })
);

export default enhance(KpiHome);
